import {
  FIELD_LANE_CHIP,
  FIELD_LANE_DISPATCH,
} from "@shared/fieldCalendarColors";
import type { FieldVisitLane } from "./fieldCalendarTypes";

export type FieldBlockVariant = "chip" | "dispatch";

const CHIP_FALLBACK = FIELD_LANE_CHIP.others;
const DISPATCH_FALLBACK = FIELD_LANE_DISPATCH.others;

export function blockClassForVisit(
  lane: FieldVisitLane | string | null | undefined,
  _prefs?: unknown,
  variant: FieldBlockVariant = "chip",
): string {
  const map = variant === "dispatch" ? FIELD_LANE_DISPATCH : FIELD_LANE_CHIP;
  const key = lane && typeof lane === "string" ? lane : "others";
  return map[key] ?? (variant === "dispatch" ? DISPATCH_FALLBACK : CHIP_FALLBACK);
}

export function blockClassForLeave(variant: FieldBlockVariant = "chip"): string {
  return variant === "dispatch" ? FIELD_LANE_DISPATCH.leave : FIELD_LANE_CHIP.leave;
}

export function laneAccentClass(lane: FieldVisitLane | string | null | undefined): string {
  if (lane === "service") return "bg-orange-500";
  if (lane === "installation") return "bg-emerald-600";
  if (lane === "programming") return "bg-violet-600";
  if (lane === "urgent") return "bg-red-600";
  if (lane === "leave") return "bg-sky-400";
  return "bg-slate-500";
}
